import { render, staticRenderFns } from "./AppNavigationListBase.vue?vue&type=template&id=9dde626a&"
import script from "./AppNavigationListBase.vue?vue&type=script&lang=js&"
export * from "./AppNavigationListBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports